import axios from 'axios';
import { stripHtml } from './sanitize';

const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

async function getJson(path) {
  const response = await axios.get(`${API_BASE}/${path}`, {
    headers: { Accept: 'application/json' },
  });

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Erro ao carregar conteúdo.');
  }

  return response.data.data;
}

const PROJECT_TEXT_FIELDS = ['description', 'fullDescription', 'challenge', 'solution'];

function cleanProject(project) {
  if (!project) {
    return project;
  }

  const cleaned = { ...project };
  PROJECT_TEXT_FIELDS.forEach((field) => {
    cleaned[field] = stripHtml(cleaned[field]);
  });
  if (Array.isArray(cleaned.results)) {
    cleaned.results = cleaned.results.map(stripHtml);
  }

  return cleaned;
}

export const fetchBrands = () => getJson('brands.php');
export const fetchProjects = () => getJson('projects.php').then((projects) => projects.map(cleanProject));
export const fetchProject = (id) =>
  getJson(`projects.php?id=${encodeURIComponent(id)}`).then(cleanProject);
export const fetchServices = () => getJson('services.php');
export const fetchCompany = () => getJson('company.php');
export const fetchAbout = () => getJson('about.php');
